import styled from '@emotion/styled';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import { Button, pxToRem } from '@modernhealth/vital-components';

import image from 'src/public/img/assessment.png';
import { useOnboardingGuard } from 'src/shared/hooks/useOnboardingGuard';
import { color, font } from 'src/shared/styles/variables';

import { BrandWrapper } from '../components/BrandWrapper';

const Wrapper = styled.div({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    textAlign: 'center',
    width: '100%',
    maxWidth: 650,
});

const Image = styled.img({
    width: 120,
    marginBottom: 10,
});

const HeadingText = styled.h2(
    {
        color: color.pickledBluewood,
        margin: '1em auto 0.7em',
        textAlign: 'center',
        maxWidth: 520,
    },
    font.black(font.size.extraLarge),
);

const DescriptionText = styled.p(
    {
        color: color.blueBayoux,
        marginBottom: '1.5em',
    },
    font.book(font.size.medium),
);

const DescriptionColorfulText = styled.span(
    {
        color: color.royalBlue,
    },
    font.heavy(font.size.medium),
);

export enum OnboardingWho5IntroStepPageTestID {
    DescriptionText = 'OnboardingWho5IntroStepPage.DescriptionText',
}

type Props = RouteComponentProps<{}, {}, { matchAttempt?: boolean }>;

const OnboardingWho5IntroStepPage: React.FC<Props> = props => {
    const shouldRender = useOnboardingGuard();
    const { t } = useTranslation();

    if (!shouldRender) {
        return null;
    }

    return (
        <BrandWrapper>
            <Wrapper>
                <Image src={image} />
                <HeadingText>{t('onboarding:onboarding_who5_intro_step_page.title')}</HeadingText>
                <DescriptionText data-testid={OnboardingWho5IntroStepPageTestID.DescriptionText}>
                    <Trans
                        t={t}
                        ns="onboarding"
                        i18nKey="onboarding_who5_intro_step_page.description"
                        components={{
                            highlight: <DescriptionColorfulText />,
                        }}
                    />
                </DescriptionText>

                <Button
                    onClick={() => props.history.push('/onboarding-survey')}
                    variant="primary"
                    css={{
                        marginTop: pxToRem(15),
                        fontSize: font.size.mediumExtended,
                        width: 'fit-content',
                        minWidth: 241,
                        paddingLeft: 0,
                        paddingRight: 0,
                    }}
                >
                    {t('common.continue')}
                </Button>
            </Wrapper>
        </BrandWrapper>
    );
};

export default OnboardingWho5IntroStepPage;
